import { FormattedMessage } from 'react-intl';

import { useTagsOptions } from '@/modules/secrets/modules/tags';
import { SearchSecretAttributeType } from '@/modules/secrets/types';
import { TagManager } from '@/services/utilities';

import { useSecretsAttributesFilter } from '../../../../hooks/useSecretsAttributesFilter';
import { SelectFilter } from '../SelectFilter';

export const TagsFilter = () => {
    const options = useTagsOptions();
    const { filter, toggleFilter } = useSecretsAttributesFilter();

    const selectedTags = filter.filter(attribute => attribute.type === SearchSecretAttributeType.TAG).map(attribute => attribute.value);

    return (
        <SelectFilter
            label={{ id: 'secret.filter.tags' }}
            mode='multiple'
            value={selectedTags}
            options={options}
            placeholder={<FormattedMessage id='secret.filter.tags.placeholder' />}
            maxTagCount={1}
            maxTagPlaceholder={omittedValues => `+${omittedValues.length}`}
            allowClear
            onSelect={(tag: string) => {
                TagManager.push('used_tags');
                toggleFilter(tag, tag, SearchSecretAttributeType.TAG, true);
            }}
            onDeselect={(tag: string) => {
                toggleFilter(tag, tag, SearchSecretAttributeType.TAG, false);
            }}
            onClear={() => {
                selectedTags.forEach(tag => {
                    toggleFilter(tag, tag, SearchSecretAttributeType.TAG, false);
                });
            }}
        />
    );
};
